/**
 * Shared API Exports
 */

export { API_CONFIG, buildApiUrl, buildStaticUrl, ApiError, handleApiResponse } from './config';
export { refreshAccessToken, fetchWithTokenRefresh } from './refreshToken';
export { chatApi } from './chat.api';
export { ordersApi } from './orders.api';
export { contractorsApi } from './contractors.api';
export type {
  CreateOrderRequest,
  OrderResponse,
  OrderType,
  OrderStatus,
} from './orders.api';
export type { WorkingHours, Service } from './contractors.api';
